import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = {
  key: 0,
  class: "mt-8 md:mt-2"
}
const _hoisted_3 = { class: "mt-2 border border-gray-400 rounded" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("option", {
  class: "capitalize",
  value: "",
  selected: "",
  disabled: ""
}, "Please select", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", {
  class: "capitalize",
  value: "1"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", {
  class: "capitalize",
  value: "2"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", {
  class: "capitalize",
  value: "3"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", {
  class: "capitalize",
  value: "4"
}, null, -1)
const _hoisted_9 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  class: "capitalize",
  value: "",
  selected: "",
  disabled: ""
}
const _hoisted_11 = {
  class: "capitalize",
  value: "facilitator"
}
const _hoisted_12 = {
  class: "capitalize",
  value: "parent"
}
const _hoisted_13 = {
  class: "capitalize",
  value: "participant"
}
const _hoisted_14 = { class: "pt-0" }
const _hoisted_15 = { class: "pt-0 capitalize" }
const _hoisted_16 = { class: "flex py-6" }
const _hoisted_17 = { class: "mt-6 overflow-clip" }
const _hoisted_18 = {
  key: 0,
  class: "mt-8 md:mt-2"
}
const _hoisted_19 = {
  key: 1,
  class: "mt-8 md:mt-2"
}
const _hoisted_20 = { class: "text-3xl font-medium capitalize" }
const _hoisted_21 = { class: "w-full mt-6 overflow-x-auto" }
const _hoisted_22 = { class: "w-full table-fixed" }
const _hoisted_23 = { class: "font-bold text-left capitalize border-b-2 border-black" }
const _hoisted_24 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_25 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_26 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_27 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-2 py-2"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "hidden" }, "Actions")
], -1)
const _hoisted_29 = { class: "px-2 py-6 capitalize md:py-3" }
const _hoisted_30 = { class: "px-2 py-6 capitalize md:py-3" }
const _hoisted_31 = { class: "px-2 py-6 capitalize md:py-3" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "px-2 py-6 capitalize md:py-3" }
const _hoisted_35 = { class: "px-2 py-2 divide-x-2 divide-gray-300" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { class: "py-2" }

import { ref } from "vue";
import { storeToRefs } from "pinia";
import { useRoute } from "vue-router";

import TabGroup from "@/components/TabGroup.vue";
import RoleGuard from "@/components/RoleGuard.vue";
// import AlertCard from "@/components/AlertCard.vue";
import ListRowItem from "@/components/ListRowItem.vue";
import TitleHeader from "@/components/TitleHeader.vue";
// import ExternalLink from "@/components/ExternalLink.vue";
import TimezoneSpan from "@/components/TimezoneSpan.vue";
import DefaultButton from "@/components/DefaultButton.vue";
import ResultsTable from "@/components/tables/ResultsTable.vue";

import api from "@/api/api";
import { userHasRole } from "@/utils/roles";
import { useGlobalStore, useUserStore } from "@/store";
import { Survey, SurveyResponse, Template, DetailedResults } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'SurveyIndex',
  async setup(__props) {

let __temp: any, __restore: any

const route = useRoute();
const { user } = storeToRefs(useUserStore());
const globalStore = useGlobalStore();

const tabs = [
  {
    id: "summary",
    name: "Summary",
    roles: ["admin"],
  },
  {
    id: "results",
    name: "Results",
    roles: ["l4a-trainer", "trainer-organisation", "admin"],
  },
  {
    id: "users",
    name: "Users",
    roles: ["l4a-trainer", "trainer-organisation", "admin"],
  },
];
const selectedTab = ref("summary");

const isSavingSurvey = ref(false);

const templates = ref([] as Template[]);
const responses = ref([] as SurveyResponse[]);
const results = ref({} as DetailedResults[]);
const survey = ref({} as Survey);

async function saveSurvey() {
  try {
    await api.surveys.updateSurvey(survey.value.id, survey.value);
    globalStore.toast("SUCCESS", "Survey updated");
  } catch (error) {
    globalStore.toast("ERROR", "Error updating Survey");
  }
}

survey.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.surveys.getSurvey(Number(route.params.id)))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.survey;
responses.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.surveys.listSurveyResponses(survey.value.id))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.responses;
templates.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.templates.listTemplates("all"))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.templates;

if (userHasRole(user.value.roles, ["admin"])) {
  selectedTab.value = "summary";
  results.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.surveys.getSurveyResultsTotal(survey.value.id))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.results;
} else {
  selectedTab.value = "results";
  results.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.surveys.getSurveyResultsByEvent(survey.value.id, route.query.id as string))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.results;
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(TitleHeader, {
        title: survey.value.name
      }, null, 8, ["title"])
    ]),
    _createVNode(RoleGuard, {
      roles: ['admin', 'clubs-admin'],
      class: "mt-6"
    }, {
      default: _withCtx(() => [
        (selectedTab.value === 'summary')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(ListRowItem, {
                  title: _ctx.$t('club-trigger')
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("select", {
                      id: "subscription",
                      class: "capitalize text-black border rounded w-full focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((survey.value.trigger_period) = $event))
                    }, _hoisted_9, 512), [
                      [_vModelSelect, survey.value.trigger_period]
                    ])
                  ]),
                  _: 1
                }, 8, ["title"]),
                _createVNode(ListRowItem, {
                  title: _ctx.$t('survey-recipient')
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("select", {
                      id: "role",
                      class: "capitalize text-black border rounded w-full focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((survey.value.role) = $event))
                    }, [
                      _createElementVNode("option", _hoisted_10, _toDisplayString(_ctx.$t("please-select")), 1),
                      _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.$t("facilitator")), 1),
                      _createElementVNode("option", _hoisted_12, _toDisplayString(_ctx.$t("parent")), 1),
                      _createElementVNode("option", _hoisted_13, _toDisplayString(_ctx.$t("participant")), 1)
                    ], 512), [
                      [_vModelSelect, survey.value.role]
                    ])
                  ]),
                  _: 1
                }, 8, ["title"]),
                _createVNode(ListRowItem, {
                  title: _ctx.$t('created-at')
                }, {
                  default: _withCtx(() => [
                    _createVNode(TimezoneSpan, {
                      date: survey.value.created_at,
                      locale: "en-GB",
                      "date-style": "short",
                      "time-style": "short"
                    }, null, 8, ["date"])
                  ]),
                  _: 1
                }, 8, ["title"]),
                _createVNode(ListRowItem, {
                  title: _ctx.$t('last-modified')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_14, [
                      _createVNode(TimezoneSpan, {
                        date: survey.value.updated_at,
                        locale: "en-GB",
                        "date-style": "short",
                        "time-style": "short"
                      }, null, 8, ["date"])
                    ])
                  ]),
                  _: 1
                }, 8, ["title"]),
                _createVNode(ListRowItem, {
                  title: _ctx.$t('status')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_15, _toDisplayString(survey.value.status), 1)
                  ]),
                  _: 1
                }, 8, ["title"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(DefaultButton, {
                  type: "primary",
                  disabled: isSavingSurvey.value,
                  loading: isSavingSurvey.value,
                  onAction: saveSurvey
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("save-survey-details")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "loading"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(RoleGuard, { roles: ['advanced-facilitator'] }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_17, [
          _createVNode(TabGroup, {
            tabs: tabs,
            selectedTab: selectedTab.value,
            onSelect: _cache[2] || (_cache[2] = (tab) => selectedTab.value = tab)
          }, null, 8, ["selectedTab"]),
          (selectedTab.value === 'results')
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value, (result, index) => {
                  return (_openBlock(), _createBlock(ResultsTable, {
                    key: result.id,
                    index: index,
                    result: result,
                    response_count: responses.value.length
                  }, null, 8, ["index", "result", "response_count"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (selectedTab.value === 'users')
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("h2", _hoisted_20, _toDisplayString(_ctx.$t("users")), 1),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("table", _hoisted_22, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", _hoisted_23, [
                        _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.$t("name")), 1),
                        _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.$t("region")), 1),
                        _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.$t("facilitator")), 1),
                        _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.$t("date-completed")), 1),
                        _hoisted_28
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(responses.value, (response) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          class: "w-full border-b border-gray-400 even:bg-gray-200",
                          key: response.id
                        }, [
                          _createElementVNode("td", _hoisted_29, _toDisplayString(response.user.first_name) + " " + _toDisplayString(response.user.last_name), 1),
                          _createElementVNode("td", _hoisted_30, _toDisplayString(response.country), 1),
                          _createElementVNode("td", _hoisted_31, [
                            (response.facilitator_id)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(response.facilitator?.first_name) + " " + _toDisplayString(response.facilitator?.last_name), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_33))
                          ]),
                          _createElementVNode("td", _hoisted_34, [
                            _createVNode(TimezoneSpan, {
                              date: response.responded_at,
                              locale: "en-GB",
                              "date-style": "short",
                              "time-style": "long"
                            }, null, 8, ["date"])
                          ]),
                          _createElementVNode("td", _hoisted_35, [
                            _createVNode(_component_router_link, {
                              to: `/dashboard/training-feedback/${survey.value.id}/responses/${response.id}/`,
                              class: "pr-2 text-blue"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("View")
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ])
                        ]))
                      }), 128)),
                      (!responses.value.length)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_36, [
                            _createElementVNode("td", _hoisted_37, _toDisplayString(_ctx.$t("no-responses-to-this-survey")), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})